<template>
  <div class='t_content_view'>
    <div class="t_title_box_f">
        <div class="t_blue_line"></div>
        <div>我的企微主体（新版智能体）</div>
    </div>
    <div class="t_tip">
        本页绑定的是新版智能体（AI Wing），可选智能体来自中台智能应用清单，绑定后代客消息由新版平台自动回复
    </div>
    <div class="t_busbox" v-for="(item,index) in complist.data" :key="index">
      <img class="t_busimg" :src="item.corp_logo_url" alt="">
      <div>
        <div style="margin-bottom: 8px;">{{ item.corp_name }}</div>
        <div style="font-size: 14px;color:#8A8A8A">
          <span style="color:#00C768">{{ item.total_online_devices }}/{{ item.total_devices }}</span>
          <span>客服坐席在线</span>
          <span style="margin-left: 15px;">粉丝数：</span>
          <span style="color:#000000">{{ item.fans_count }}</span>
          <span style="margin-left: 15px;">接待客服：{{ item.customers_count }}</span>
          <span style="margin-left: 15px;">AI客服：</span>
          <el-dropdown trigger="click" style="cursor: pointer;" >
            <span class="el-dropdown-link">
              {{ item.corp_agent_config.name || '未绑定' }}
              <el-icon class="el-icon--right">
                <arrow-down />
              </el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item2,index2) in agentlist.data" :key="index2" @click="selectagent(item,item2)">{{ item2.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div @click="openpz(item)" class="t_pz">企微配置</div>
      <div @click="opensjk(item)" class="t_pz2">数据库配置</div>
    </div>
    <div @click="openpz()" class="t_busbox" style="justify-content: center;cursor: pointer;align-items: center;color: #5578F2;">
      <el-icon style="margin-right: 5px;"><Plus /></el-icon>添加主体
    </div>
  </div>

<!-- 添加主体 -->
    <peizhibus v-if="isshowpz" :isshowpz="isshowpz" :bjitem="bjitem" :fromtype="2" @addbus="addbus" @closedpz="closedpz" />

<!-- 配置数据库 -->
    <el-dialog
      v-model="isshowsjk"
      title="绑定数据库"
      width="650px"
      :close-on-click-modal="false"
    >
      <div class="t_tip">
        绑定数据库后可实现用户订单、状态等信息联查，AI客服可根据用户问题自行从库中寻找答案
      </div>
      <div style="width: 500px;margin: 0 auto;">
        <div class="t_pz_input">
          <div class="t_pz_title">库类型：</div>
          <el-select style="width: 270px;" v-model="sjkform.data.data_type"  >
            <el-option label="体育" :value="1"></el-option>
            <el-option label="敢探号" :value="2"></el-option>
          </el-select>
          <div  style="color:#2B4EFF;cursor: pointer;margin-left: 10px;width: 182px;flex-shrink: 0;flex-grow: 0;">
            <span @click="web_openlink1" v-if="sjkform.data.data_type == '2'">了解如何获取敢探号配置参数</span>
            <span @click="web_openlink2" v-if="sjkform.data.data_type == '1'">了解如何获取体育配置参数</span>
          </div>

        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">APPID：</div>
          <el-input  v-model="sjkform.data.out_app_id" placeholder="请输入APPID" />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">app key：</div>
          <el-input  v-model="sjkform.data.out_app_key" placeholder="请输入app key" />
        </div>
        <div class="t_pz_input">
          <div class="t_pz_title">回调地址：</div>
          <el-input  v-model="sjkform.data.out_callback_url" placeholder="请输入回调地址" />
        </div>
      </div>

      <div style="display: flex;justify-content: center;margin-top: 30px;">
        <el-button @click="addsjk" color="#4F46E5" style="width: 100px;" type="primary">添加</el-button>
      </div>
    </el-dialog>
</template>

<script setup>
import { ref, reactive,  provide, onBeforeMount, onMounted,watch } from 'vue'
import { ElMessage, ElMessageBox,UploadProps, UploadUserFile } from 'element-plus'
import { newaddcomp,neweditcomp,newgetcomplist,neweditght,newgetaiwinglist,newchooseaiwing } from '@/assets/js/common.js'
import  peizhibus  from '../components/peizhibus.vue'

//是否显示注册主体
const isshowpz = ref(false)

//确认添加主体
const addbus = ()=>{
    getlist()
    isshowpz.value = false

}



//编辑数据
const bjitem = reactive({
  data:{}
})

//打开添加
const openpz = (item)=>{
  if(item){
    bjitem.data = item
  }else{
    bjitem.data = {}
  }
  isshowpz.value = true
}

//关闭
const closedpz = ()=>{
    isshowpz.value = false
}

//主体列表
const complist = reactive({
  data:[]
})

//获取列表
const getlist = ()=>{
  newgetcomplist().then((response)=>{
      if (response.data.msg.code == 0) {
            console.log('列表')
            console.log(response.data)
            complist.data = response.data.data
      }
  })
}

//是否显示数据库配置弹窗
const isshowsjk = ref(false)

//编辑敢探号信息1
const sjkform = reactive({
  data:{
    corp_id:'',
    data_type:'',
    out_app_id:'',
    out_app_key:'',
    out_callback_url:''
  }
})

//打开数据库配置弹窗1
const opensjk = (item)=>{
  console.log(item)
  sjkform.data.corp_id = item.id
  sjkform.data.data_type = item.data_type
  sjkform.data.out_app_id = item.out_app_id
  sjkform.data.out_app_key = item.out_app_key
  sjkform.data.out_callback_url = item.out_callback_url

  isshowsjk.value = true
}

//确认添加数据库配置12
const addsjk = ()=>{
  neweditght(sjkform.data).then((response)=>{
    if (response.data.msg.code == 0) {
      ElMessage.success('添加成功!')
      getlist()
      isshowsjk.value = false
    }
  })

}

//打开网页1
const web_openlink1 = ()=>{
    window.open(window.location.origin +  '/wenjian/如何获取敢探号配置参数.pdf','_blank')
}

//打开网页2
const web_openlink2 = ()=>{
    window.open(window.location.origin +  '/wenjian/如何获取体育配置参数.pdf','_blank')
}
//新版智能体列表
const agentlist = reactive({
  data:[]
})

//获取新版智能体列表
const getagentlist = ()=>{
  newgetaiwinglist().then((response)=>{
      if (response.data.msg.code == 0) {
            console.log('新版智能体列表')
            console.log(response.data)
            agentlist.data = response.data.data
      }
  })
}

//绑定新版智能体
const selectagent = (item,item2)=>{
  console.log(item,item2)
  var obj = JSON.parse(JSON.stringify(item2))
  obj.to_corp_id = item.id
  newchooseaiwing(obj).then((response)=>{
    if (response.data.msg.code == 0) {
      ElMessage.success('绑定成功')
      getlist()
    }
  })
}

onMounted(() => {
    console.log('onMounted')
    getlist()
    getagentlist()
})


</script>
<style scoped>
  .t_busbox{
    background-color: #FAFAFA;
    display: flex;
    box-sizing: border-box;
    padding: 30px 25px;
    margin-top: 20px;
    margin-bottom: 20px;
    position: relative;
    width: 700px;
  }
  .t_busimg{
    width: 55px;
    height: 55px;
    margin-right: 15px;
    border-radius: 50%;
  }
  .t_pz{
    position: absolute;
    right: 120px;
    top: 20px;
    cursor: pointer;
    color: #646AFC;
    font-size: 15px;
  }
    .t_pz2{
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    color: #646AFC;
    font-size: 15px;
  }
  .t_pz_input{
    display: flex;
    margin-bottom: 20px;
    align-items: center;
  }
  .t_pz_title{
    width: 100px;
    text-align: right;
  }
  .t_pz_inw{
    width: 300px;
  }
  :deep(.avatar-uploader .el-upload){
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

:deep( .avatar-uploader .el-upload:hover) {
  border-color: var(--el-color-primary);
}

:deep( .el-icon.avatar-uploader-icon) {
  font-size: 29px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  text-align: center;
}
  .avatar-uploader .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .t_tip{
    font-size: 15px;
    color: #666666;
    background-color: #F4F9FF;
    padding: 10px 15px;
    margin-bottom: 20px;
  }
</style>
